import { __ } from "@wordpress/i18n";
import { 
  useBlockProps, 
  InnerBlocks,
  useInnerBlocksProps
} from "@wordpress/block-editor";
import { Button } from "@wordpress/components";
import { useState } from "@wordpress/element";

export default function Edit({ attributes, setAttributes, clientId }) {
  const blockProps = useBlockProps({ className: "tabs-block" });
  const [activeTab, setActiveTab] = useState(0);

  // Configure InnerBlocks to only allow tab-item blocks
  const innerBlocksProps = useInnerBlocksProps(
    {},
    {
      allowedBlocks: ['puroclean/tab-item'],
      template: [
        ['puroclean/tab-item', {
          title: 'Storm Damage and Flash Floods',
          linkText: 'Learn More About Storm Damage',
          linkUrl: '#storm-damage',
          showLink: true
        }],
        ['puroclean/tab-item', {
          title: 'Overflowing Bathtubs & Sinks',
          linkText: 'Learn More About Overflow Damage',
          linkUrl: '#overflow-damage',
          showLink: true
        }],
        ['puroclean/tab-item', {
          title: 'Pipes and Supply Line Leaks',
          linkText: 'Learn More About Pipe Leaks',
          linkUrl: '#pipe-leaks',
          showLink: true
        }]
      ],
      templateLock: false,
      renderAppender: () => (
        <Button
          variant="primary"
          onClick={() => {
            // Add a new tab-item block
                        wp.data.dispatch('core/block-editor').insertBlock(
              wp.blocks.createBlock('puroclean/tab-item', {
                title: `Tab ${wp.data.select('core/block-editor').getBlocks(clientId).length + 1}`,
      linkText: 'Learn More',
      linkUrl: '#',
      showLink: true
              }),
              undefined,
              clientId
            );
          }}
          className="block-editor-button-block-appender"
        >
          {__('Add Tab', 'puroclean')}
        </Button>
      )
    }
  );

  // Get inner blocks to create tab navigation
  const innerBlocks = wp.data.select('core/block-editor').getBlocks(clientId) || [];

  return (
    <div {...blockProps}>
      <div className="container max-w-content mx-auto px-4 py-12">
          <div style={{
            background: '#FFFFFF',
            boxShadow: '0px 0px 20px rgba(0,0,0,0.06)',
            borderRadius: '10px',
            padding: '32px'
          }}>
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Left Side - Tab Navigation */}
              <div className="lg:w-1/3">
                <div style={{
                  background: '#F6F6F6',
                  borderRadius: '10px',
                  padding: '24px'
                }}>
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold">{__('Tabs', 'puroclean')}</h3>
                  </div>
                  
                  <div className="space-y-2">
                  {innerBlocks.map((block, index) => (
                      <div 
                      key={block.clientId}
                        className={`w-full text-left p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                          index === activeTab 
                            ? 'bg-blue-100 border-blue-500 text-blue-700' 
                            : 'bg-white border-transparent hover:border-gray-300'
                        }`}
                        onClick={() => setActiveTab(index)}
                      >
                        <div className="flex items-center justify-between">
                          <span className="font-medium flex-1">
                          {block.attributes.title || `Tab ${index + 1}`}
                          </span>
                          
                          <div className="flex gap-1">
                            {/* Up/Down Reorder Buttons */}
                            {index > 0 && (
                              <Button
                                variant="tertiary"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                wp.data.dispatch('core/block-editor').moveBlockToPosition(
                                  block.clientId,
                                  clientId,
                                  clientId,
                                  index - 1
                                );
                                }}
                                label={__('Move Up', 'puroclean')}
                                className="px-2 py-1"
                              >
                                ↑
                              </Button>
                            )}
                          {index < innerBlocks.length - 1 && (
                              <Button
                                variant="tertiary"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                wp.data.dispatch('core/block-editor').moveBlockToPosition(
                                  block.clientId,
                                  clientId,
                                  clientId,
                                  index + 1
                                );
                                }}
                                label={__('Move Down', 'puroclean')}
                                className="px-2 py-1"
                              >
                                ↓
                              </Button>
                            )}
                            
                            {/* Remove Button */}
                            <Button
                              variant="tertiary"
                              size="small"
                              isDestructive
                              onClick={(e) => {
                                e.stopPropagation();
                              wp.data.dispatch('core/block-editor').removeBlock(block.clientId);
                              }}
                              label={__('Remove', 'puroclean')}
                              className="px-2 py-1"
                            >
                              🗑️
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Side - Tab Content */}
              <div className="lg:w-2/3">
              {innerBlocks.length === 0 ? (
                <div className="text-center py-12">
                  <h3 className="text-xl font-semibold mb-4 text-gray-600">{__('No Tabs Configured', 'puroclean')}</h3>
                  <p className="text-gray-500 mb-4">{__('Click "Add Tab" to create your first interactive tab.', 'puroclean')}</p>
                  <div {...innerBlocksProps} />
                </div>
              ) : (
                <div {...innerBlocksProps} />
              )}
            </div>
          </div>
          </div>
      </div>
    </div>
  );
}